import api from "../../utils/api/api.utils";
export var updateGenerator = function (paramsGenerator) {
    var resource = paramsGenerator.resource;
    return function (params) {
        return api.put("/".concat(resource, "/").concat(params.id), { data: params.data });
    };
};
